<template>
  <div class="conference-brochure">
    <div class="header">
      <div class="w padding flex">
        <span>FinLLM 2023</span>
        <div class="right">
          <img
            src="@/assets/img/ijcai.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="centen-box w padding">
      <h1 class="big-title">Accepted Papers</h1>
      <div class="cente-text mg-bottom">
        <div class="cente-title mg">
          Zhihua Jin, Xin Jiang, Xingbo Wang, Qun Liu, Yong Wang, Xiaozhe Ren and Huamin Qu
        </div>
        NumGPT: Improving Numeracy Ability of Generative Pre-trained Models
        <div class="link">
          （<a
            href="https://arxiv.org/abs/2109.03137"
            target="_blank"
            >https://arxiv.org/abs/2109.03137</a
          >）
        </div>

        <div class="cente-title">Maxime Labonne and Sean Moran</div>
        Spam-T5: Benchmarking Large Language Models for Few-Shot Email Spam Detection
        <div class="link">
          （<a
            href="https://arxiv.org/abs/2304.01238"
            target="_blank"
            >https://arxiv.org/abs/2304.01238</a
          >）
        </div>

        <div class="cente-title">Yinyu Lan, Yanru Wu, Wang Xu, Weiqiang Feng and Youhao Zhang</div>
        Chinese Fine-Grained Financial Sentiment Analysis with Large Language Models
        <div class="link">
          （<a
            href="https://arxiv.org/abs/2306.14096"
            target="_blank"
            >https://arxiv.org/abs/2306.14096</a
          >）
        </div>

        <div class="cente-title">Junyang Li, Shuoling Liu, Liyuan Chen and Qiang Yang</div>
        Financial Large Language Models: A Survey

        <div class="cente-title">Ziao Wang, Jianning Wang, Junda Wu and Xiaofeng Zhang</div>
        An Effective Data Creation Pipeline for Generating High-quality Financial Instruction Data
        <div class="link">
          （<a
            href="https://arxiv.org/abs/2308.01415"
            target="_blank"
            >https://arxiv.org/abs/2308.01415</a
          >）
        </div>

        <div class="cente-title">Boyu Zhang, Hongyang Yang and Xiao-Yang Liu</div>
        Instruct-FinGPT: Financial Sentiment Analysis by Instruction Tuning of General-Purpose Large Language Models
        <div class="link">
          （<a
            href="https://arxiv.org/abs/2306.12659"
            target="_blank"
            >https://arxiv.org/abs/2306.12659</a
          >）
        </div>

        <div class="cente-title">Hongyang Yang, Xiao-Yang Liu and Christina Dan Wang</div>
        FinGPT: Open-Source Financial Large Language Models
        <div class="link">
          （<a
            href="https://arxiv.org/abs/2306.06031"
            target="_blank"
            >https://arxiv.org/abs/2306.06031</a
          >）
        </div>

        <div class="cente-title">Liangru Xie, Wenxiang Jiang, Yiming Luo, Yushan Pan and Hao Wang</div>
        The Challenges of LLMs in Financial Services

        <div class="cente-title">
          Yujie Ding, Shuai Jia, Tianyi Ma, Bingcheng Mao, Xiuze Zhou, Liuliu Li, Dongming Han and Ming Chen
        </div>
        Integrating Stock Features and Global Information via Large Language Models for Enhanced Stock Return Prediction
        <div class="link">
          （<a
            href="https://arxiv.org/abs/2310.05627"
            target="_blank"
            >https://arxiv.org/abs/2310.05627</a
          >）
        </div>

        <div class="cente-title">Haohan Zhang, Fengrui Hua, Chengjin Xu, Jian Guo, Hao Kong and Ruiting Zuo</div>
        Unveiling the Potential of Sentiment: Can Large Language Models Predict Chinese Stock Price Movements?
        <div class="link">
          （<a
            href="https://arxiv.org/abs/2306.14222"
            target="_blank"
            >https://arxiv.org/abs/2306.14222</a
          >）
        </div>

        <div class="cente-title">Shuoling Liu, Gaoguo Jia, Yuhang Jiang, Liyuan Chen and Qiang Yang</div>
        Can ChatGPT Overcome Behavioral Biases in the Financial Sector? Classify-and-Rethink: Multi-Step Zero-Shot
        Reasoning in the Gold Investment
        <div class="link">
          （<a
            href="https://arxiv.org/abs/2411.13599"
            target="_blank"
            >https://arxiv.org/abs/2411.13599</a
          >）
        </div>

        <div class="cente-title">Ziao Wang, Yuhang Li, Junda Wu, Jaehyeon Soon and Xiaofeng Zhang</div>
        FinVis-GPT: A Multimodal Large Language Model for Financial Chart Analysis
        <div class="link">
          (<a
            href="https://arxiv.org/abs/2308.01430"
            target="_blank"
            >https://arxiv.org/abs/2308.01430</a
          >)
        </div>

        <div class="cente-title">Xuanyu Zhang, Qing Yang and Dongliang Xu</div>
        XuanYuan: A Large Chinese Financial Chat Model with Hundreds of Billions Parameters
        <div class="link">
          (<a
            href="https://arxiv.org/abs/2305.12002"
            target="_blank"
            >https://arxiv.org/abs/2305.12002</a
          >)
        </div>

        <div class="cente-title">Xuanyu Zhang, Bingbing Li and Qing Yang</div>
        CGCE: A Chinese Generative Chat Evaluation Benchmark for General and Financial Domains
        <div class="link">
          (<a
            href="https://arxiv.org/abs/2305.14471"
            target="_blank"
            >https://arxiv.org/abs/2305.14471</a
          >)
        </div>
      </div>
    </div>
    <div class="footer padding">
      <div>
        <div class="email-icon"></div>
        <div class="email-info">
          <p>If you have any question, feel free to contact us:</p>
          <p style="color: #b3ebff">finllm2023@easychair.org</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
@import '../../style/public.less';
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header,
.footer {
  min-width: 1715px;
  height: 103px;
  line-height: 103px;
  font-size: 28px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 700;
  background: url('@/assets/img/CTA.png') no-repeat;
  background-size: cover;
  .right {
    width: 172px;
    height: 64px;
    @media (max-width: 750px) {
      width: 300px;
      height: 120px;
    }
    img {
      width: 100%;
      height: 100%;
      vertical-align: top;
    }
  }
}
.footer {
  height: 151px;
  margin-top: 100px;
  font-size: 20px;
  color: #ffffff;
  font-weight: 500;
  display: flex;
  align-items: center;
  & > div {
    display: flex;
    .email-icon {
      width: 30px;
      height: 30px;
      margin-right: 9px;
      background: url('@/assets/img/email.png') no-repeat;
      background-size: cover;
    }
    p {
      margin: 0;
      line-height: 1.5;
    }
  }
}
.padding {
  padding: 0 130px;
}
.title {
  font-size: 40px;
  color: #0d152e;
  font-weight: 600;
  margin-top: 59px;
  @media (max-width: 750px) {
    font-size: 60px;
  }
}
.big-title {
  @media (max-width: 750px) {
    font-size: 60px;
  }
}
.cente-text {
  font-size: 20px;
  color: #81838c;
  text-align: justify;
  line-height: 1.5;

  @media (max-width: 750px) {
    font-size: 40px;
  }

  .cente-title {
    font-size: 26px;
    color: #81838c;
    margin-top: 68px;
    font-weight: 500;
    text-align: left;

    @media (max-width: 750px) {
      font-size: 52px;
    }
  }
  .mg {
    margin-top: 25px !important;
  }
}
.centen-box {
  margin-top: 50px;
  h1 {
    font-size: 32px;
    color: #0d152e;
    line-height: 2;
    font-weight: 600;
    display: flex;
    align-items: center;
    @media (max-width: 750px) {
      font-size: 50px;
    }
    &::before {
      content: '';
      display: inline-block;
      width: 10px;
      height: 35px;
      background-color: #4774f4;
      margin-right: 10px;
      vertical-align: baseline;
      @media (max-width: 750px) {
        height: 50px;
      }
    }
  }
  .text {
    font-size: 20px;
    color: #81838c;
    text-align: justify;
    line-height: 1.5;
    font-weight: 400;
    margin-bottom: 30px;
    @media (max-width: 750px) {
      font-size: 40px;
    }
    .email {
      color: #0088ff;
    }
  }
  .link {
    display: block;
    font-size: 20px;
    color: #0088ff;
    line-height: 2;
    font-weight: 400;
    margin-bottom: 20px;
    @media (max-width: 750px) {
      font-size: 40px;
    }
  }
  .process {
    font-size: 20px;
    color: #81838c;
    line-height: 2;
    font-weight: 400;
    @media (max-width: 750px) {
      font-size: 40px;
    }
    span {
      color: #1eb9e1;
    }
    .process-img {
      display: flex;
      margin-bottom: 28px;
      @media (max-width: 750px) {
        justify-content: space-between;
      }
      & > div {
        width: 200px;
        margin-right: 30px;
        @media (max-width: 750px) {
          width: 48%;
          margin: 0;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
.cente-text {
  font-size: 20px;
  color: #81838c;
  text-align: justify;
  line-height: 1.5;

  @media (max-width: 750px) {
    font-size: 40px;
  }

  .cente-title {
    font-size: 26px;
    color: #81838c;
    margin-top: 68px;
    font-weight: 500;
    text-align: left;

    @media (max-width: 750px) {
      font-size: 52px;
    }
  }
}

.mg-bottom {
  margin-bottom: 50px;
}
@media (max-width: 750px) {
  .header,
  .footer {
    min-width: 375px;
  }
  .header {
    height: 200px;
    line-height: 200px;
    font-size: 80px;
  }
  .w {
    min-width: 100vw;
    max-width: 100vw;
  }
}
.jz-box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  img {
    width: 48%;
    margin-bottom: 50px;
  }
}
</style>
